import React, { useState } from "react";

// ? MUI Components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

// ? Github icon
import GitHubIcon from "@mui/icons-material/GitHub";
import { Menu, MenuItem, Tooltip } from "@mui/material";

import "../index.css";

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div id="header">
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            id="basic-button"
            aria-controls={open ? "nav" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="nav"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleClose}>
              <a className="links" href="/">
                Home
              </a>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <a className="links" href="/pokedex">
                Pokedex
              </a>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <a className="links" href="/updates">
                Updates and logs
              </a>
            </MenuItem>
          </Menu>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Poekmon App
          </Typography>
          <Tooltip title="Follow me on github" arrow>
            <a href="https://github.com/SnowDingo">
              <IconButton style={{ color: "white" }} variant="text">
                <GitHubIcon />
              </IconButton>
            </a>
          </Tooltip>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Header;
